import React, { Dispatch } from 'react';
import { Box, Button, Collapse } from '@mui/material';
import { classes } from '../../Job/Applications/styles';
import DeleteIcon from '@mui/icons-material/Delete';
import { ITableColumns, TemplateTableAction, TemplateTableState } from '../types';
import { ModalType } from '../config';

export default function JobTemplateActionsPanel({
  JobState,
  JobDispatch
}: {
  JobState: TemplateTableState<ITableColumns>;
  JobDispatch: Dispatch<TemplateTableAction>;
}) {
  return (
    <Collapse in={JobState.templateTableState.selectedItems.length >= 1}>
      <Box sx={classes.actionsContianer}>
        <Button
          id="job-templates-bulk-delete-button"
          variant="outlined"
          startIcon={<DeleteIcon sx={{ color: '#E37D7A' }} />}
          sx={classes.actionButton}
          onClick={() =>
            JobDispatch({
              type: 'SET_MODALS_OPEN',
              payload: ModalType.BULK_DELETE_JOB_TEMPLATES
            })
          }
        >
          Bulk Delete
        </Button>
      </Box>
    </Collapse>
  );
}
